const DEFAULT_MELTWATER_REDUX_STATE = {
  category: 'all',
  news: [],
  sentiment: 'all',
};

export default DEFAULT_MELTWATER_REDUX_STATE;
